var ErrorReporting = (function () {
    function ErrorReporting() {
    }
    ErrorReporting.init = function () {
    };
    ErrorReporting.captureException = function (error, opts) {
        console.log('captureException', error, opts);
    };
    ErrorReporting.setUser = function (id, email, name) {
    };
    return ErrorReporting;
}());
export default ErrorReporting;



//////////////////
// WEBPACK FOOTER
// ./src/utils/ErrorReporting.ts
// module id = null
// module chunks = 